var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calculator 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66683 1.33398H11.3335C11.6871 1.33398 12.0263 1.47446 12.2763 1.72451C12.5264 1.97456 12.6668 2.3137 12.6668 2.66732V13.334C12.6668 13.6876 12.5264 14.0267 12.2763 14.2768C12.0263 14.5268 11.6871 14.6673 11.3335 14.6673H4.66683C4.31321 14.6673 3.97407 14.5268 3.72402 14.2768C3.47397 14.0267 3.3335 13.6876 3.3335 13.334V2.66732C3.3335 2.3137 3.47397 1.97456 3.72402 1.72451C3.97407 1.47446 4.31321 1.33398 4.66683 1.33398ZM4.66683 2.66732V5.33398H11.3335V2.66732H4.66683ZM4.66683 6.66732V8.00065H6.00016V6.66732H4.66683ZM7.3335 6.66732V8.00065H8.66683V6.66732H7.3335ZM10.0002 6.66732V8.00065H11.3335V6.66732H10.0002ZM4.66683 9.33398V10.6673H6.00016V9.33398H4.66683ZM7.3335 9.33398V10.6673H8.66683V9.33398H7.3335ZM10.0002 9.33398V10.6673H11.3335V9.33398H10.0002ZM4.66683 12.0007V13.334H6.00016V12.0007H4.66683ZM7.3335 12.0007V13.334H8.66683V12.0007H7.3335ZM10.0002 12.0007V13.334H11.3335V12.0007H10.0002Z",
    fill: "#4E5968"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator1);
export default __webpack_public_path__ + "static/media/Calculator1.9ecb10566b1532bcecbb03b1d1ee8288.svg";
export { ForwardRef as ReactComponent };